import React, { useState } from "react";
import "../assets/css/Products.css";
import ContactOptions from "./ContactOptions";

import gaoConnector from "../assets/img/product/gao_connector.jpg";
import gaoSaude from "../assets/img/product/gao_saude.jpg";
import gaoEdu from "../assets/img/product/gao_edu.jpg";
import gaoCms from "../assets/img/product/gao_cms.jpg";
import gaoIa from "../assets/img/product/gao_ia.jpg";

const ProductCard = ({ imgSrc, imgAlt, title, description }) => (
  <div className="card card-product d-flex flex-column align-items-start gap-4 color-card-change-orange">
    <div className="container-imagem">
      <img className="container-imagem-size" src={imgSrc} alt={imgAlt} />
    </div>
    <h2 className="title-product">{title}</h2>
    <p className="text-product">{description}</p>
  </div>
);

const Products = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-3">
      <div className="container-products d-flex flex-column justify-content-center align-items-center gap-3">
        <div className="text-title-product">
          Nossos Produtos
        </div>
        <button className="bottom-orange z-2" onClick={handleShow}>
          Entre em contato
        </button>
        <div className="row justify-content-center align-items-center gap-3">
          <ProductCard
            imgSrc={gaoConnector}
            imgAlt="Conexão"
            title="GAO-CONNECTOR"
            description="Integre seus sistemas e plataformas digitais de forma ágil e simples com o GAO CONNECTOR. Tenha um painel intuitivo para monitorar integrações em tempo real e visualizar a origem e o destino dos dados, garantindo eficiência e transparência nos processos."
          />
          <ProductCard
            imgSrc={gaoSaude}
            imgAlt="Saúde"
            title="GAO-SAÚDE"
            description="Otimize a gestão da sua clínica ou consultório com o GAO SAÚDE. Agendamento de consultas, prontuários médicos e emissão de receitas em uma plataforma única, aumentando a produtividade da equipe e a eficiência do atendimento."
          />
          <ProductCard
            imgSrc={gaoEdu}
            imgAlt="CMS"
            title="GAO-EDUSAFE"
            description="É uma plataforma para controle de acesso e monitoramento, seu uso é de reconhecimento facial, RFID, QR Code e Biometria, suas notificações são em tempo real para os responsáveis. Com a Dashboard inteligente para administradores educacionais."
          />
        </div>
        <div className="row justify-content-center align-items-center gap-3">
          <ProductCard
            imgSrc={gaoCms}
            imgAlt="Conexão"
            title="GAO-CMS"
            description="Simplifique a gestão de atendimentos, compras, contratos e financeiro com o GAO CMS. Com integração para emissão de boletos, automatize processos e melhore a produtividade e o controle financeiro, tudo em uma plataforma centralizada."
          />
          <ProductCard
            imgSrc={gaoIa}
            imgAlt="Saúde"
            title="GAO-SISTEMA IA"
            description="Sistema de Multi-atendimento de com, múltiplos canais e usuários, com integração dos modelos de inteligência artificial. "
          />
        </div>
      </div>
      <div id="history-container"></div>
      <ContactOptions show={showModal} handleClose={handleClose} />
    </div>
  );
};

export default Products;
